import introductie from "@/content/handleiding/introductie.md?raw";
import seizoenInrichten from "@/content/handleiding/seizoen-inrichten.md?raw";
import wedstrijddagen from "@/content/handleiding/wedstrijddagen.md?raw";
import stamgegevens from "@/content/handleiding/stamgegevens.md?raw";
import bevoegdheden from "@/content/handleiding/bevoegdheden.md?raw";
import inschrijfperiodes from "@/content/handleiding/inschrijfperiodes.md?raw";
import aankondiging from "@/content/handleiding/aankondiging.md?raw";
import namensHandelen from "@/content/handleiding/namens-handelen.md?raw";
import reistijden from "@/content/handleiding/reistijden.md?raw";
import planning from "@/content/handleiding/planning.md?raw";
import promoties from "@/content/handleiding/promoties.md?raw";
import wedstrijdboekjes from "@/content/handleiding/wedstrijdboekjes.md?raw";
import lokaleAccounts from "@/content/handleiding/lokale-accounts.md?raw";
import synchronisaties from "@/content/handleiding/synchronisaties.md?raw";

export type HandleidingPagina = {
  slug: string;
  titel: string;
  markdown: string;
};

/**
 * Ordered by hand in the order a seizoen is built (#102), which is not the sidebar's order: the
 * bezetting matrix and the bevoegdheden gate the inschrijving but outlive a seizoen (ADR-0028).
 * Dutch and never read through i18next, per the location-based language rule settled on #81.
 */
export const handleidingPaginas: HandleidingPagina[] = [
  { slug: "introductie", titel: "Introductie", markdown: introductie },
  { slug: "seizoen-inrichten", titel: "Een seizoen inrichten", markdown: seizoenInrichten },
  { slug: "wedstrijddagen", titel: "Wedstrijddagen en banen", markdown: wedstrijddagen },
  { slug: "stamgegevens", titel: "Stamgegevens", markdown: stamgegevens },
  { slug: "bevoegdheden", titel: "Bevoegdheden", markdown: bevoegdheden },
  { slug: "inschrijfperiodes", titel: "Inschrijfperiodes", markdown: inschrijfperiodes },
  { slug: "aankondiging", titel: "Aankondiging en herinnering", markdown: aankondiging },
  { slug: "namens-handelen", titel: "Namens handelen", markdown: namensHandelen },
  { slug: "reistijden", titel: "Reistijden", markdown: reistijden },
  { slug: "planning", titel: "De planning", markdown: planning },
  { slug: "promoties", titel: "Promoties", markdown: promoties },
  { slug: "wedstrijdboekjes", titel: "Wedstrijdboekjes", markdown: wedstrijdboekjes },
  { slug: "lokale-accounts", titel: "Accounts", markdown: lokaleAccounts },
  { slug: "synchronisaties", titel: "Synchronisaties", markdown: synchronisaties },
];
